import React, { useState, useEffect } from "react";
import { TabButtonFlatButton } from "../../../common-components";
import { colors } from "../../../../themes/Colors";
import {
  ActionBar,
  AddAgentPopUpDisplay,
  AgentHeader,
  AgentListItem,
  UserPopUpDisplay,
} from "./components";

const AgentsDisplay = ({
  companyServiceArray,
  setCompanyServicesArray,
  companyInformation,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
}) => {
  const [tableDisplay, setTableDisplay] = useState("agents");
  const [agentTopUp, setAgentTopUp] = useState(false);

  const [search, setSearch] = useState("");

  const [addAgentPopUp, setAddAgentPopUp] = useState(false);

  const [refresh, setRefresh] = useState(false);

  const [selectedAgent, setSelectedAgent] = useState(null);

  const [agentsArray, setAgentsArray] = useState(null);
  const getCompanyAgents = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/agency/getAllAgentsForAdmin",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth.userId,
            companyId: auth.companyId,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setAgentsArray(respnseData.agentUsers);

        // setToastPop(true);
        // setPopUpTitle("SUCCESS");
        // setMessage(respnseData.success);
        setLoading(false);

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage(respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(
        "No network, contact support if you have a data connectin and are still unable to connect"
      );
      setToastPop(true);
      console.log("error", err);
    }
  };

  const NameAssemble = ({ agent }) => {
    let name;
    if (agent) {
      name =
        agent.firstName +
        agent.lastName +
        agent.cellNumber +
        agent.email +
        agent.Team +
        agent.type;
    }
    return name;
  };

  useEffect(() => {
    if (companyInformation) {
      getCompanyAgents();
    }
  }, [companyInformation, refresh]);
  return (
    <div
      style={{
        flex: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {agentTopUp ? null : (
        <div style={{ position: "fixed", top: 30, display: "flex" }}>
          <div style={{ marginLeft: 10 }}>
            {/* <TabButtonFlatButton
              title={"TEAM BREAKDOWN"}
              backgroundColor={
                tableDisplay === "registered"
                  ? colors.secondaryGrey
                  : colors.secondaryDarkBlue
              }
              textColor={
                tableDisplay === "registered"
                  ? colors.secondaryDarkBlue
                  : colors.white
              }
              onClick={() => setTableDisplay("registered")}
            /> */}
          </div>
          {/* <div style={{ marginLeft: 5 }}> */}
          <TabButtonFlatButton
            title={"AGENTS"}
            backgroundColor={
              tableDisplay === "agents"
                ? colors.secondaryGrey
                : colors.secondaryDarkBlue
            }
            textColor={
              tableDisplay === "agents"
                ? colors.secondaryDarkBlue
                : colors.white
            }
            onClick={() => setTableDisplay("agents")}
          />
          {/* </div> */}

          {/* <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"AGENT PERFORMANCE"}
              backgroundColor={
                tableDisplay === "sla"
                  ? colors.secondaryGrey
                  : colors.secondaryDarkBlue
              }
              textColor={
                tableDisplay === "sla" ? colors.secondaryDarkBlue : colors.white
              }
              onClick={() => setTableDisplay("sla")}
            />
          </div> */}
        </div>
      )}
      <ActionBar
        onAddClick={() => setAddAgentPopUp(true)}
        search={search}
        onSearchChange={(e) => setSearch(e.target.value)}
        title={"AGENTS LIST"}
      />
      <AgentHeader />
      <div
        style={{
          flex: 1,
          // borderStyle: "solid",
          display: "flex",
          flexDirection: "column",
          overflowY: "scroll",
          overflowX: "hidden",
          justifyContent: "flex-start",
          alignItems: "center ",
          maxHeight: 750,
        }}
      >
        <div style={{ minHeight: 5 }} />
        {agentsArray
          ? agentsArray.map((agent, index) => {
              return NameAssemble({ agent })
                .toLocaleLowerCase()
                .match(search.toLocaleLowerCase()) ? (
                <div key={index} style={{ width: "100%" }}>
                  {" "}
                  <AgentListItem
                    userName={(
                      agent.firstName +
                      " " +
                      agent.lastName
                    ).toLocaleUpperCase()}
                    onClick={() => {
                      setAgentTopUp(true);
                      setSelectedAgent(agent);
                    }}
                    cellNumber={agent.cellNumber}
                    email={agent.email}
                    team={agent.Team}
                    type={agent.type}
                  />
                </div>
              ) : null;
            })
          : "loading"}
      </div>
      <UserPopUpDisplay
        display={agentTopUp}
        setUserPopUp={setAgentTopUp}
        selectedAgent={selectedAgent}
        setSelectedAgent={setSelectedAgent}
      />
      <AddAgentPopUpDisplay
        display={addAgentPopUp}
        setAddAgentPopUp={setAddAgentPopUp}
        companyInformation={companyInformation}
        setLoading={setLoading}
        setToastPop={setToastPop}
        setPopUpTitle={setPopUpTitle}
        setMessage={setMessage}
        auth={auth}
        refresh={refresh}
        setRefresh={setRefresh}
      />
    </div>
  );
};
export default AgentsDisplay;
